var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckLightTheme = function SvgCheckLightTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000",
    fillOpacity: 0.9,
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3 7.3l1.4 1.4L12 25.4l-8.7-8.7 1.4-1.4 7.3 7.3"
  }))));
};
export default SvgCheckLightTheme;